export const Namespace = (namespace) => {
  let parts = namespace.split('.');
  let space = $$;
  if (parts[0] === '$$') {
    parts = parts.slice(1);
  }
  for (let i = 0, l = parts.length; i < l; i += 1) {
    if (space[parts[i]] === undefined) {
      space[parts[i]] = {};
    }
    space = space[parts[i]];
  }
  return space;
};